const Columns = [
    {
        Header: "#",
        accessor: "id",
    },
    {
        Header: "Name",
        accessor: "partner.type",
    },
    {
        Header: "Partner",
        accessor: "partner.name",
    },
    {
        Header: "Created",
        accessor: "",
    },
    {
        Header: "A1",
        accessor: "a1",
    },
    {
        Header: "A2",
        accessor: "a2",
    },
    {
        Header: "A3",
        accessor: "a3",
    },
    {
        Header: "Source",
        accessor: "source",
    },
    {
        Header: "Medium",
        accessor: "medium",
    },
    {
        Header: "Campaign",
        accessor: "campaign",
    },
    {
        Header: "City",
        accessor: "additionalDetails.location.district",
    },
    {
        Header: "State",
        accessor: "additionalDetails.location.state",
    },
    {
        Header: "Pincode",
        accessor: "additionalDetails.location.pincode",
    },
    {
        Header: "Type",
        accessor: "type",
    },
    {
        Header: "Platform",
        accessor: "additionalDetails.platform",
    },
    {
        Header: "Lost",
        accessor: "additionalDetails.lost",
    },
    {
        Header: "Lost Reason",
        accessor: "additionalDetails.lostReason",
    },
    {
        Header: "Status",
        accessor: "status",
    },
    {
        Header: "Order Value",
        accessor: "additionalDetails.orderValue",
    },
    // {
    //     Header: "NextCallback",
    //     accessor: "",
    // },
    {
        Header: "Coupon",
        accessor: "additionalDetails.couponCode",
    },
    {
        Header: "Comment",
        accessor: "comment",
    },
    {
        Header: "Action",
        accessor: "action",
    },
];
export { Columns };